function toggleSidebar(){
    return {
        type: 'TOGGLE_SIDEBAR'
    }
}

export default {
    toggleSidebar
}